import LandmarkLayer from './landmarkLayer';
import HeatMapLayer from './HeatMapLayer';
import Path from './Path';
import Camera from './Camera';
import BarLayer from './BarLayer';
import Area from './Area';
import Marker3D from './Marker3D';
import Bubble from './Bubble';
import ODLineLayer from './ODLineLayer';
import TrailLayer from './TrailLayer';
import Model from './Model';
import RoadSgHeatLayer from './roadSgHeatLayer';
import Agg3DColumnLayer from './agg3DColumnLayer';
import GridColumnLayer from './GridColumnLayer';
import OverlayTip from './OverlayTip';
import TypeAreaLayer from './TypeAreaLayer';
import Events from './Events';
import Building from './Building';
import EventLayer from './EventLayer';

import TrackLayer from './TrackLayer';
let TimerList = {}

let Common = {
  initUE() {
    window.appInstance = new TGApp.App()
    window.appInstance.initService({
      name: 'serviceName',
      container: document.getElementById('container'),
      mode: 'streaming3',
      url: streamingConfig.url,
      token: streamingConfig.token,
      // resolution: [streamingConfig.width, streamingConfig.height],
      editMode: false,
    })
  },
  initAVW() {
    window.appInstance = new TGApp.App()
    // 服务信息
    const serve = streamingConfig.serve;
    const item = streamingConfig.mapList[0];

    // 短地址
    const sceneUrl = `${serve}/publish/scene/api/${item.id}`;
    const tokenUrl = `${serve}/api/user/v1/visitorScene/${item.id}`;

    let xhr = new XMLHttpRequest();
    xhr.open('post', tokenUrl, true);
    xhr.setRequestHeader('Content-Type', 'application/json charset=utf-8');
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        let result = JSON.parse(xhr.responseText);
        appInstance.initService(
          {
            container: document.getElementById('container'),
            mode: 'scene2',
            url: sceneUrl,
            token: result.accessToken,
            editMode: false,
          }
        )
      }
    };
    xhr.send(JSON.stringify({ password: 'sfasds' }));
  },
  loadService(item) {
    const serve = streamingConfig.serve;
    // 短地址
    const sceneUrl = `${serve}/publish/scene/api/${item.id}`;
    const tokenUrl = `${serve}/api/user/v1/visitorScene/${item.id}`;
    console.log(sceneUrl, tokenUrl);
    let xhr = new XMLHttpRequest();
    xhr.open('post', tokenUrl, true);
    xhr.setRequestHeader('Content-Type', 'application/json charset=utf-8');
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        let result = JSON.parse(xhr.responseText);
        appInstance.uniCall(
          'loadService',
          {
            name: item.name,
            container: document.getElementById('container'),
            mode: 'scene',
            url: sceneUrl,
            token: result.accessToken,
            resolution: [streamingConfig.width, streamingConfig.height],        // 控件 像素分辨率，宽，高
            editMode: false,
          },
          res => {
            console.log('loadService', item.name, res);
          }
        )
      }
    };
    xhr.send(JSON.stringify({ password: 'sfasds' }));
  },
  switchService(name) {
    appInstance.uniCall(
      'switchService',
      { name: name },
      (res) => {
        console.log('切换场景', name, res)
      }
    )
  },
  switchScene(name) {
    appInstance.uniCall(
      'switchScene',
      {
        name: name,
        duration: 1,
      },
      (res) => {
        console.log('切换场景', name, res)
      }
    )
  },
  removeOverlay(params) {
    window.appInstance.uniCall('removeOverlay', {
      "id": params.id,
      "overlayType": params.overlayType,
    }, res => {
      console.log(`删除图层`, params, res);
    });
  },
  clearOverlayType(type) {
    TrailLayer.clearTrailLayerTimers();
    window.appInstance.uniCall('clearOverlayType', {
      "overlayType": type,
    }, res => {
      console.log(`清空图层${type}`, res);
    });
  },
  setLayerVisible(layer, isVisible = true) {
    if (!layer) {
      return
    };
    window.appInstance.uniCall('setOverlayVisibility', {
      id: layer.id,
      overlayType: layer.layerConfig.layerType,
      visible: isVisible,
    }, res => {
      console.log(`设置图层显隐-${layer.id}-${isVisible}`, res);
    });
  },
  clearTrailTimer() {
    TrailLayer.clearTrailLayerTimers();
  }
}
export default {
  LandmarkLayer,
  ODLineLayer,
  HeatMapLayer,
  Path,
  Camera,
  BarLayer,
  Area,
  Marker3D,
  Bubble,
  TrailLayer,
  Common,
  TimerList,
  Model,
  RoadSgHeatLayer,
  Agg3DColumnLayer,
  GridColumnLayer,
  OverlayTip,
  TypeAreaLayer,
  Events,
  Building,
  EventLayer,
  TrackLayer
}